module.exports = {"history":"Historie"}